import { makeStyles, tokens } from '@fluentui/react-components';

export const useMetricsTileStyles = makeStyles({
    root: {
        height: 'fit-content',
    },
    hightlighted: {
        background: tokens.colorNeutralBackground3,
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        gap: '5px',
        width: '100%',
    },
    headerRow: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '10px',
        alignItems: 'center',
    },
    content: {
        display: 'flex',
        gap: '32px',
        justifyContent: 'space-between',

        '&.vertical': {
            flexDirection: 'column',

            '&.reversed': {
                flexDirection: 'column-reverse',
            },
        },

        '&.reversed': {
            flexDirection: 'row-reverse',
        },
    },
    valueContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        gap: '8px',
        padding: '8px',
        maxWidth: '100%',
    },
    currentHighlight: {
        borderRadius: '6px',
        backgroundColor: tokens.colorBrandBackground2,
    },
    noDataLabel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
    },
});
